import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

// Old-style FLYTRIP panel sidebar: groups expand to show sub-items one below another.
export const SideAccordion = ({ groups, active, onSelect, testPrefix }) => {
  const owner = groups.find((g) => g.children?.some((c) => c.id === active))?.id;
  const [open, setOpen] = useState(owner || null);
  const isOpen = (g) => open === g.id;

  return (
    <nav className="space-y-1.5" data-testid={`${testPrefix}-side-accordion`}>
      {groups.map((g) => {
        const Icon = g.icon;
        if (!g.children) {
          const on = active === g.id;
          return (
            <button key={g.id} onClick={() => { setOpen(null); onSelect(g); }} data-testid={`${testPrefix}-nav-${g.id}`}
              className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 text-[15px] transition-colors ${on ? "bg-[#1B1F5B] font-semibold text-white" : "text-slate-700 hover:bg-slate-50"}`}>
              <Icon className="h-[18px] w-[18px]" /><span className="flex-1 text-left">{g.label}</span>
            </button>
          );
        }
        const expanded = isOpen(g);
        return (
          <div key={g.id} className={expanded ? "overflow-hidden rounded-lg bg-[#E8EEFB]" : ""}>
            <button onClick={() => setOpen(expanded ? null : g.id)} data-testid={`${testPrefix}-group-${g.id}`}
              className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 text-[15px] transition-colors ${expanded ? "bg-[#1B1F5B] font-semibold text-white shadow-md" : "text-slate-700 hover:bg-slate-50"}`}>
              <Icon className="h-[18px] w-[18px]" /><span className="flex-1 text-left">{g.label}</span>
              {expanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4 text-slate-400" />}
            </button>
            {expanded && (
              <div className="space-y-0.5 px-2 py-2">
                {g.children.map((c) => {
                  const CI = c.icon;
                  const on = active === c.id;
                  return (
                    <button key={c.id} onClick={() => onSelect(c)} data-testid={`${testPrefix}-nav-${c.id}`}
                      className={`flex w-full items-center gap-2.5 rounded-md px-3 py-2.5 text-[14px] transition-colors ${on ? "border-l-4 border-[#1B1F5B] bg-white font-semibold text-[#1B1F5B] shadow-sm" : "text-slate-700 hover:bg-white/70"}`}>
                      {CI && <CI className="h-4 w-4" />}<span className="flex-1 text-left">{c.label}</span>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default SideAccordion;
